import { render, staticRenderFns } from "./datasiswa.vue?vue&type=template&id=5e4cbd0d&"
import script from "./datasiswa.vue?vue&type=script&lang=js&"
export * from "./datasiswa.vue?vue&type=script&lang=js&"
import style0 from "./datasiswa.vue?vue&type=style&index=0&id=5e4cbd0d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports